<main class="main-content has-sidebar">
  <div class="bg-white h-full px-8 py-6">
    <div class="filtro-segmentacao" *ngIf="segmentacaoAtual === 0">
      <div
        class="form-control-group flex flex-col space-y-6"
        *appTemPermissao="EnumPermissao.FazerSegmentacao"
      >
        <label
          for=""
          class="text-sm font-medium text-brand-purple-300 flex items-center justify-between w-full"
        >
          Segmentação
          <button
            *ngIf="mostrarBotaoLimpar()"
            class="text-xs text-brand-purple-300 btn-limpar-filtros"
            (click)="limparFiltro()"
            title="Limpar todos os filtros aplicados"
          >
            Limpar filtros
          </button>
        </label>
        <select
          class="form-select bg-brand-primary text-white"
          (change)="onSegmentacaoChange($event)"
          [(ngModel)]="segmentacaoAtual"
        >
          <option value="0" selected>Adicionar segmentação</option>
          <option value="8">Abrangência</option>
          <option value="6">Secretaria</option>
          <option value="5">Regime</option>
          <option value="1">Local</option>
          <option value="3">Cargo</option>
          <option value="4">Faixa salarial</option>
          <option value="7">Contato</option>
          <option value="9">Idade</option>
          <option value="10">Persona de crédito</option>
        </select>
      </div>

      <div class="space-y-2">
        <app-exibir-segmentacao
          titulo="Abrangência"
          [itens]="this.filtrosSegmentacao.abrangencia ?? []"
          [tipoFiltro]="8"
          (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>
        <app-exibir-segmentacao
          titulo="Secretaria"
          [itens]="this.filtrosSegmentacao.secretarias ?? []"
          [tipoFiltro]="6"
          (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>
        <app-exibir-segmentacao
          titulo="Regime"
          [itens]="this.filtrosSegmentacao.regimes ?? []"
          [tipoFiltro]="5"
          (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>
        <app-exibir-segmentacao
          titulo="Local"
          [itens]="getValoresExibirSegmentacao(1)"
          [tipoFiltro]="1"
          (editarClick)="abrirEdicaoFiltro($event)"
        ></app-exibir-segmentacao>
        <app-exibir-segmentacao
          titulo="Cargo"
          [itens]="this.filtrosSegmentacao.cargos ?? []"
          [tipoFiltro]="3"
          (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>
        <app-exibir-segmentacao 
            titulo="Persona de Crédito"
            [itens]="this.filtrosSegmentacao.personaCredito ?? []"
            [tipoFiltro]="10"
            (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>        
        <app-exibir-segmentacao
          titulo="Faixa salarial"
          [itens]="this.filtrosSegmentacao.faixasSalariais ?? []"
          [tipoFiltro]="4"
          (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>
        <app-exibir-segmentacao
          titulo="Contato"
          [itens]="getValoresExibirSegmentacao(7)"
          [tipoFiltro]="7"
          (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>
        <app-exibir-segmentacao
          titulo="Idade"
          [itens]="getValoresExibirSegmentacao(9)"
          [tipoFiltro]="9"
          (editarClick)="abrirEdicaoFiltro($event)"
        >
        </app-exibir-segmentacao>
      </div>
    </div>

    <!-- Filtro de Segmentação - Local -->
    <div
      class="filtro-cargos flex-col gap-6 flex"
      *ngIf="segmentacaoAtual === 1"
    >
      <div class="filtros__header flex items-center justify-between">
        <h3 class="text-sm font-medium text-brand-purple-300">Local</h3>
        <div class="actions flex items-center gap-4">
          <button
            class="text-brand-primary"
            (click)="exibirInicioSegmentacao()"
          >
            <span class="material-symbols-outlined"> close </span>
          </button>
        </div>
      </div>
      <div class="filtros__conteudo flex-1">
        <p class="font-semibold">Selecione os estados</p>
        <p class="text-sm text-brand-gray-400 mt-4" *ngIf="loadingUfs">
          Carregando...
        </p>
        <div
          class="flex flex-col space-y-2 mt-2 mb-2 filtros-uf"
          *ngIf="!loadingUfs"
        >
          <label *ngFor="let uf of optUfs" class="text-sm text-brand-gray-400">
            <input
              type="checkbox"
              [value]="uf.chave"
              (change)="adicionarUf(uf)"
              [checked]="uf.checked"
            />
            {{ uf.valor }}
          </label>
        </div>
      </div>
      <div class="filtros__conteudo flex-1" data-filter-group>
        <div class="input-group icon--after">
          <ng-select
            [items]="optCidades"
            bindLabel="valor"
            bindValue="chave"
            [typeahead]="pesquisaCidadesUF$"
            placeholder="Pesquisar..."
            notFoundText="Nenhum item encontrado"
            typeToSearchText="Digite para pesquisar..."
            addTagText="Adicionar novo item"
            [searchable]="true"
            [clearable]="true"
            (change)="adicionarRemoverCidade($event)"
            class="sem-seta form-control"
            loadingText="Carregando..."
            [loading]="loadingCidades"
            [closeOnSelect]="true"
          >
          </ng-select>
          <span class="material-symbols-outlined icon">more_horiz</span>
        </div>
        <div class="list-wrapper mt-4">
          <ul class="space-y-2" data-filter-list>
            <li
              class="bg-brand-purple-50 p-2 text-sm flex items-center min-h-8 rounded"
              *ngFor="let cidade of optCidadesSelecionadas"
            >
              {{
                cidade.valor == ""
                  ? cidade.uf + ": Todas as cidades"
                  : cidade.valor
              }}
              <button
                type="button"
                class="btn text-brand-primary ml-auto"
                (click)="adicionarRemoverCidade(cidade)"
                *ngIf="cidade.valor !== ''"
              >
                <span class="material-symbols-outlined filled">delete</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <footer class="filtros_footer flex items-center justify-between gap-2">
        <button
          class="btn btn-secondary flex-1"
          (click)="this.exibirInicioSegmentacao()"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary flex-1"
          (click)="atualizarSegmentacao(optCidadesSelecionadas)"
        >
          OK
        </button>
      </footer>
    </div>

    <!-- Filtro de Segmentação - Idade -->
    <div
      class="filtro-cargos flex-col gap-6 flex"
      *ngIf="segmentacaoAtual === 9"
    >
      <div class="filtros__header flex items-center justify-between">
        <h3 class="text-sm font-medium text-brand-purple-300">Idade</h3>
        <div class="actions flex items-center gap-4">
          <button class="text-brand-primary" (click)="limparCamposIdade()">
                <span class="material-symbols-outlined filled">
                    delete
                </span>
            </button>
          <button
            class="text-brand-primary"
            (click)="exibirInicioSegmentacao()"
          >
            <span class="material-symbols-outlined"> close </span>
          </button>
        </div>
      </div>
      <div class="filtros__conteudo flex-1">
        <div class="flex flex-col space-y-4 mt-2 mb-2 filtros-uf">
          <div class="flex flex-col space-y-1">
            <label for="idadeDe" class="text-sm text-brand-gray-400"
              >De (idade mínima)</label
            >
            <input
              type="text"
              id="idadeDe"
              [(ngModel)]="filtroIdade.de"
              (input)="validarCampoIdade($event, 'de')"
              (blur)="validarLimiteIdade($event, 'de')"
              class="form-control"
              placeholder="De"
              maxlength="3"
            />
          </div>

          <div class="flex flex-col space-y-1">
            <label for="idadeAte" class="text-sm text-brand-gray-400"
              >Até (idade máxima)</label
            >
            <input
              type="text"
              id="idadeAte"
              [(ngModel)]="filtroIdade.ate"
              (input)="validarCampoIdade($event, 'ate')"
              (blur)="validarLimiteIdade($event, 'ate')"
              class="form-control"
              placeholder="Até"
              maxlength="3"
            />
          </div>
        </div>
      </div>
      <footer class="filtros_footer flex items-center justify-between gap-2">
        <button
          class="btn btn-secondary flex-1"
          (click)="this.exibirInicioSegmentacao()"
        >
          Cancelar
        </button>
        <button
          class="btn btn-primary flex-1"
          (click)="SalvarCamposIdade()"
        >
          OK
        </button>
      </footer>
    </div>

    <!-- Filtro checkbox -->
    <app-filtro-checkbox
      *ngIf="segmentacaoAtual === 8"
      titulo="Abrangência"
      [tipoFiltro]="8"
      [subTitulo]="'Selecione a abrangência'"
      [itensSelecionados]="
        converterStringArrayToChaveValor(filtrosSegmentacao.abrangencia)
      "
      (salvar)="atualizarSegmentacao($event)"
      (cancelar)="this.exibirInicioSegmentacao()"
      [permiteExcluirTodos]="false"
    >
    </app-filtro-checkbox>

    <app-filtro-checkbox
      *ngIf="segmentacaoAtual === 7"
      titulo="Contato"
      [tipoFiltro]="7"
      [subTitulo]="'Selecione os tipos de contatos'"
      [itensSelecionados]="filtrosSegmentacao.contatos"
      (salvar)="atualizarSegmentacao($event)"
      (cancelar)="this.exibirInicioSegmentacao()"
      >>
    </app-filtro-checkbox>

    <app-filtro-checkbox
      *ngIf="segmentacaoAtual === 4"
      titulo="Faixa salarial"
      [tipoFiltro]="4"
      [subTitulo]="'Selecione: '"
      [itensSelecionados]="
        converterStringArrayToChaveValor(filtrosSegmentacao.faixasSalariais)
      "
      (salvar)="atualizarSegmentacao($event)"
      (cancelar)="this.exibirInicioSegmentacao()"
      >>
    </app-filtro-checkbox>
    <!-- Filtro checkbox -->

    <!-- Filtros pesquisáveis -->
    <app-filtro-pesquisavel
      *ngIf="segmentacaoAtual === 3"
      titulo="Cargos"
      [tipoFiltro]="3"
      [itensSelecionados]="
        converterStringArrayToChaveValor(filtrosSegmentacao.cargos)
      "
      (salvar)="atualizarSegmentacao($event)"
      (cancelar)="this.exibirInicioSegmentacao()"
      >>
    </app-filtro-pesquisavel>
    <app-filtro-pesquisavel 
      *ngIf="segmentacaoAtual === 10" 
      titulo="Persona de Crédito" 
      [tipoFiltro]="10"
      [itensSelecionados]="converterStringArrayToChaveValor(filtrosSegmentacao.personaCredito)"
      (salvar)="atualizarSegmentacao($event)" 
      (cancelar)="this.exibirInicioSegmentacao()"
    >>
    </app-filtro-pesquisavel>
    <app-filtro-pesquisavel
      *ngIf="segmentacaoAtual === 6"
      titulo="Secretaria"
      [tipoFiltro]="6"
      [itensSelecionados]="
        converterStringArrayToChaveValor(filtrosSegmentacao.secretarias)
      "
      (salvar)="atualizarSegmentacao($event)"
      (cancelar)="this.exibirInicioSegmentacao()"
      >>
    </app-filtro-pesquisavel>
    <app-filtro-pesquisavel
      *ngIf="segmentacaoAtual === 5"
      titulo="Regime"
      [tipoFiltro]="5"
      [itensSelecionados]="
        converterStringArrayToChaveValor(filtrosSegmentacao.regimes)
      "
      (salvar)="atualizarSegmentacao($event)"
      (cancelar)="this.exibirInicioSegmentacao()"
      >>
    </app-filtro-pesquisavel>
    <!-- Filtros pesquisáveis -->
  </div>

  <!-- Gráficos -->
  <div>
    <div class="p-8 bg-brand-purple-50 flex items-center sticky top-0 z-[2]">
      <button
        class="btn btn-primary ml-auto"
        [disabled]="
          contadores.oportunidadesNumber === 0 ||
          loadingOportunidades ||
          !permissaoService.hasPermission(EnumPermissao.GerarListaContatos) ||
          verificandoListaExistente
        "
        [title]="
          permissaoService.hasPermission(EnumPermissao.GerarListaContatos)
            ? 'Gerar lista de contatos'
            : 'Você não tem permissão para gerar lista de contatos'
        "
        [style]="
          permissaoService.hasPermission(EnumPermissao.GerarListaContatos)
            ? ''
            : 'pointer-events: all;'
        "
        (click)="verificarPreGravacao()"
      >
        Gerar lista de contatos
      </button>
    </div>
    <div class="main-content__area">
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-2">
        <div
          class="bg-white py-4 px-6 flex items-center justify-between rounded-lg"
        >
          <div
            class="icon bg-brand-purple-50 w-12 aspect-square rounded-full flex items-center justify-center"
          >
            <span
              class="material-symbols-outlined text-brand-purple-300 filled"
            >
              groups
            </span>
          </div>
          <div class="text-right">
            <p class="text-xs text-brand-gray-400">Oportunidades</p>
            <app-carregando
              [showCarregando]="loadingOportunidades"
              [isChart]="false"
            ></app-carregando>
            <p
              class="text-xl text-brand-gray-400 font-medium"
              *ngIf="!loadingOportunidades"
            >
              {{ contadores.oportunidadesNumber | formatarNumeroBR }}
            </p>
          </div>
        </div>
        <div
          class="bg-white py-4 px-6 flex items-center justify-between rounded-lg"
        >
          <div
            class="icon bg-brand-purple-50 w-12 aspect-square rounded-full flex items-center justify-center"
          >
            <span
              class="material-symbols-outlined text-brand-purple-300 filled"
            >
              phone_iphone
            </span>
          </div>
          <div class="text-right">
            <p class="text-xs text-brand-gray-400">Telefones</p>
            <app-carregando
              [showCarregando]="loadingTelefones"
              [isChart]="false"
            ></app-carregando>
            <p
              class="text-xl text-brand-gray-400 font-medium"
              *ngIf="!loadingTelefones"
            >
              {{ contadores.telefones }}
            </p>
          </div>
        </div>
        <div
          class="bg-white py-4 px-6 flex items-center justify-between rounded-lg"
        >
          <div
            class="icon bg-brand-purple-50 w-12 aspect-square rounded-full flex items-center justify-center"
          >
            <span
              class="material-symbols-outlined text-brand-purple-300 outlined"
            >
              mail
            </span>
          </div>
          <div class="text-right">
            <p class="text-xs text-brand-gray-400">E-mails</p>
            <app-carregando
              [showCarregando]="loadingEmails"
              [isChart]="false"
            ></app-carregando>
            <p
              class="text-xl text-brand-gray-400 font-medium"
              *ngIf="!loadingEmails"
            >
              {{ contadores.emails }}
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 xl:grid-cols-2 mt-6 gap-6">
        <div>
          <div class="chart-wrapper">
            <h2 class="chart-title">Situação do CPF</h2>
            <app-carregando
              [showCarregando]="loadingSituacaoDocumentos"
            ></app-carregando>
            <div
              echarts
              [options]="situacaoDocumentosOptions"
              class="chart-item"
              [style]="{ height: '250px' }"
            ></div>
          </div>
        </div>
        <div>
          <div class="chart-wrapper">
            <h2 class="chart-title">Persona por Geração</h2>
            <app-carregando
              [showCarregando]="loadingPersonasPorGeracao"
            ></app-carregando>
            <div
              echarts
              [options]="personasPorGeracaoOptions"
              class="chart-item"
              [style]="{ height: '250px' }"
            ></div>
          </div>
        </div>

        <div>
          <div class="chart-wrapper">
            <h2 class="chart-title">Score</h2>
            <app-carregando [showCarregando]="loadingScore"></app-carregando>
            <div
              echarts
              [options]="scoreOptions"
              class="chart-item"
              [style]="{ height: '250px' }"
            ></div>
          </div>
        </div>
        <div>
          <div class="chart-wrapper">
            <h2 class="chart-title">Persona Digital</h2>
            <app-carregando
              [showCarregando]="loadingPersonaDigital"
            ></app-carregando>
            <div
              echarts
              [options]="personaDigitalOptions"
              class="chart-item"
              [style]="{ height: '250px' }"
            ></div>
          </div>
        </div>
        <div>
          <div class="chart-wrapper">
            <h2 class="chart-title">Flags de Telefonia</h2>
            <app-carregando
              [showCarregando]="loadingFlagsTelefonia"
            ></app-carregando>
            <div
              echarts
              [options]="flagsTelefoniaOptions"
              class="chart-item"
              [style]="{ height: '250px' }"
            ></div>
          </div>
        </div>

        <div>
          <div class="chart-wrapper">
            <h2 class="chart-title">Faixa Salarial</h2>
            <app-carregando
              [showCarregando]="loadingFaixaSalarial"
            ></app-carregando>
            <div
              echarts
              [options]="faixaSalarialOptions"
              class="chart-item"
              [style]="{ height: '250px' }"
            ></div>
          </div>
        </div>

        <div class="col-span-2">
          <div class="chart-wrapper">
            <app-carregando
              [showCarregando]="loadingNuvemPalavras"
            ></app-carregando>
            <div
              echarts
              [options]="nuvemPalavrasOptions"
              class="chart-item words-cloud"
              [style]="{ height: '250px' }"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <app-modal-lista-contato
      [qtdRegistros]="qtdRegistrosDisponiveis"
      [filtro]="filtrosSegmentacao"
      [continuarExtracao]="continuarExtracaoContatos"
    >
    </app-modal-lista-contato>
  </div>
  <!-- Gráficos -->

  <!-- Painel lateral edição -->
  <div class="painel-lateral-filtro" [class.aberto]="mostrarPainelLateral">
    <div class="painel-lateral-conteudo">
      <!-- Filtro Local (UF e Cidades) -->
      <div *ngIf="filtroEmEdicao === 1">
        <div class="filtros__conteudo flex-1">
          <p class="font-semibold">Selecione os estados</p>
          <p class="text-sm text-brand-gray-400 mt-4" *ngIf="loadingUfs">
            Carregando...
          </p>
          <div
            class="flex flex-col space-y-2 mt-2 mb-2 filtros-uf"
            *ngIf="!loadingUfs"
          >
            <label
              *ngFor="let uf of optUfs"
              class="text-sm text-brand-gray-400"
            >
              <input
                type="checkbox"
                [value]="uf.chave"
                (change)="adicionarUf(uf)"
                [checked]="uf.checked"
              />
              {{ uf.valor }}
            </label>
          </div>
        </div>
        <div class="filtros__conteudo flex-1" data-filter-group>
          <div class="input-group icon--after">
            <ng-select
              [items]="optCidades"
              bindLabel="valor"
              bindValue="chave"
              [typeahead]="pesquisaCidadesUF$"
              placeholder="Pesquisar..."
              notFoundText="Nenhum item encontrado"
              typeToSearchText="Digite para pesquisar..."
              addTagText="Adicionar novo item"
              [searchable]="true"
              [clearable]="true"
              (change)="adicionarRemoverCidade($event)"
              class="sem-seta form-control"
              loadingText="Carregando..."
              [loading]="loadingCidades"
              [closeOnSelect]="true"
            >
            </ng-select>
            <span class="material-symbols-outlined icon">more_horiz</span>
          </div>
          <div class="list-wrapper mt-4">
            <ul class="space-y-2" data-filter-list>
              <li
                class="bg-brand-purple-50 p-2 text-sm flex items-center min-h-8 rounded"
                *ngFor="let cidade of optCidadesSelecionadas"
              >
                {{
                  cidade.valor == ""
                    ? cidade.uf + ": Todas as cidades"
                    : cidade.valor
                }}
                <button
                  type="button"
                  class="btn text-brand-primary ml-auto"
                  (click)="adicionarRemoverCidade(cidade)"
                  *ngIf="cidade.valor !== ''"
                >
                  <span class="material-symbols-outlined filled">delete</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Filtro Checkbox para Abrangência -->
      <div *ngIf="filtroEmEdicao === 8">
        <app-filtro-checkbox
          [tipoFiltro]="8"
          [subTitulo]="'Selecione a abrangência'"
          [itensSelecionados]="
            converterStringArrayToChaveValor(filtrosSegmentacao.abrangencia)
          "
          (salvar)="confirmarFiltroLateral($event)"
          (cancelar)="fecharPainelLateral()"
          [permiteExcluirTodos]="false"
          [painelLateral]="true"
        >
        </app-filtro-checkbox>
      </div>

      <!-- Filtro Checkbox para Contato -->
      <div *ngIf="filtroEmEdicao === 7">
        <app-filtro-checkbox
          [tipoFiltro]="7"
          [subTitulo]="'Selecione os tipos de contatos'"
          [itensSelecionados]="filtrosSegmentacao.contatos"
          (salvar)="confirmarFiltroLateral($event)"
          (cancelar)="fecharPainelLateral()"
          [painelLateral]="true"
        >
        </app-filtro-checkbox>
      </div>

      <!-- Filtro Checkbox para Faixa Salarial -->
      <div *ngIf="filtroEmEdicao === 4">
        <app-filtro-checkbox
          [tipoFiltro]="4"
          [subTitulo]="'Selecione: '"
          [itensSelecionados]="
            converterStringArrayToChaveValor(filtrosSegmentacao.faixasSalariais)
          "
          (salvar)="confirmarFiltroLateral($event)"
          (cancelar)="fecharPainelLateral()"
          [painelLateral]="true"
        >
        </app-filtro-checkbox>
      </div>

      <!-- Filtro Pesquisavel para Cargos -->
      <div *ngIf="filtroEmEdicao === 3">
        <app-filtro-pesquisavel
          [tipoFiltro]="3"
          [itensSelecionados]="
            converterStringArrayToChaveValor(filtrosSegmentacao.cargos)
          "
          (salvar)="confirmarFiltroLateral($event)"
          (cancelar)="fecharPainelLateral()"
          [painelLateral]="true"
        >
        </app-filtro-pesquisavel>
      </div>

      <!-- Filtro Pesquisavel para Persona de Crédito -->
      <div *ngIf="filtroEmEdicao === 10">
        <app-filtro-pesquisavel 
          [tipoFiltro]="10"
          [itensSelecionados]="converterStringArrayToChaveValor(filtrosSegmentacao.personaCredito)"
          (salvar)="confirmarFiltroLateral($event)" 
          (cancelar)="fecharPainelLateral()"
          [painelLateral]="true">
        </app-filtro-pesquisavel>
      </div>

      <!-- Filtro Pesquisavel para Secretaria -->
      <div *ngIf="filtroEmEdicao === 6">
        <app-filtro-pesquisavel
          [tipoFiltro]="6"
          [itensSelecionados]="
            converterStringArrayToChaveValor(filtrosSegmentacao.secretarias)
          "
          (salvar)="confirmarFiltroLateral($event)"
          (cancelar)="fecharPainelLateral()"
          [painelLateral]="true"
        >
        </app-filtro-pesquisavel>
      </div>

      <!-- Filtro Pesquisavel para Regime -->
      <div *ngIf="filtroEmEdicao === 5">
        <app-filtro-pesquisavel
          [tipoFiltro]="5"
          [itensSelecionados]="
            converterStringArrayToChaveValor(filtrosSegmentacao.regimes)
          "
          (salvar)="confirmarFiltroLateral($event)"
          (cancelar)="fecharPainelLateral()"
          [painelLateral]="true"
        >
        </app-filtro-pesquisavel>
      </div>

      <!-- Filtro Idade -->
      <div *ngIf="filtroEmEdicao === 9">
        <div class="filtro-cargos-contatos flex-col gap-6 flex">
          <div class="filtros__header flex items-center justify-between">
              <h3 class="text-sm font-medium text-brand-purple-300">Idade</h3>
              <div class="actions flex items-center gap-4">
                  <button class="text-brand-primary" (click)="limparCamposIdade()">
                      <span class="material-symbols-outlined filled">
                          delete
                      </span>
                  </button>
                  <button class="text-brand-primary" (click)="fecharPainelLateral()">
                      <span class="material-symbols-outlined">
                          close
                      </span>
                  </button>
              </div>
          </div>
          <div class="filtros__conteudo flex-1">
              <div class="flex flex-col space-y-4 mt-2 mb-2 filtros-uf">
                <div class="flex flex-col space-y-1">
                  <label for="idadeDe" class="text-sm text-brand-gray-400"
                    >De (idade mínima)</label
                  >
                  <input
                    type="text"
                    id="idadeDe"
                    [(ngModel)]="filtroIdade.de"
                    (input)="validarCampoIdade($event, 'de')"
                    (blur)="validarLimiteIdade($event, 'de')"
                    class="form-control"
                    placeholder="De"
                    maxlength="3"
                  />
                </div>

                <div class="flex flex-col space-y-1">
                  <label for="idadeAte" class="text-sm text-brand-gray-400"
                    >Até (idade máxima)</label
                  >
                  <input
                    type="text"
                    id="idadeAte"
                    [(ngModel)]="filtroIdade.ate"
                    (input)="validarCampoIdade($event, 'ate')"
                    (blur)="validarLimiteIdade($event, 'ate')"
                    class="form-control"
                    placeholder="Até"
                    maxlength="3"
                  />
                </div>
              </div>
          </div>
          <footer class="filtros_footer flex items-center justify-between gap-2">
              <button class="btn btn-secondary flex-1" (click)="fecharPainelLateral()">Cancelar</button>
              <button class="btn btn-primary flex-1" (click)="SalvarCamposIdade()">OK</button>
          </footer>
        </div>        
      </div>
    </div>
  </div>
  <div
    class="overlay"
    [class.visible]="mostrarPainelLateral"
    (click)="fecharPainelLateral()"
  ></div>
</main>

<!-- Modal de Aviso de Listas Existentes -->
<div
  class="modal fade"
  id="modalAvisoListasExistentes"
  tabindex="-1"
  aria-labelledby="modalAvisoListasExistentesLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAvisoListasExistentesLabel">
          Atenção
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p *ngIf="qtdRegistrosDisponiveis > 0">
          Existem <strong>{{ qtdRegistrosDisponiveis }}</strong> contatos
          disponíveis para extração.
        </p>
        <p *ngIf="qtdRegistrosDisponiveis > 0">
          Clique em <strong>"Continuar Extração"</strong> para prosseguir de
          onde parou.
        </p>
        <p *ngIf="qtdRegistrosDisponiveis === 0">
          Todos os contatos da lista já foram extraídos.
        </p>
        <p *ngIf="qtdRegistrosDisponiveis === 0">
          Para extrair novamente desde o início, clique em
          <strong>Reiniciar Extração</strong>.
        </p>
      </div>
      <div class="modal-footer gap-2">
        <button
          type="button"
          class="btn btn-primary"
          (click)="continuarExtracao()"
          [disabled]="qtdRegistrosDisponiveis <= 0"
        >
          Continuar Extração
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="reiniciarExtracao()"
        >
          Reiniciar Extração
        </button>
      </div>
    </div>
  </div>
</div>
<toast-container></toast-container>
